// extracted by mini-css-extract-plugin
export default {"scrollableContent":"MultiLineTextField_scrollableContent__ZVXtf"};